// extracted by mini-css-extract-plugin
module.exports = {"highlight-notification":"style_highlight-notification__2ndVA","news":"style_news__3iQcA","newsText":"style_newsText__hjTp8","close":"style_close__1EEHS"};